import Vue from "vue";

Vue.filter("lnBrHtml", function (value: string): string {
  if (!value) return "";
  return value.replace(/\n/g, "<br/>");
});
